import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const TONES = {
  gray: { head: 'from-gray-50 to-gray-100/50 border-gray-200', icon: 'bg-primary-100 text-primary-600' },
  teal: { head: 'from-teal-50 to-teal-100/50 border-teal-200', icon: 'bg-teal-100 text-teal-600' },
  amber: { head: 'from-amber-50 to-orange-50/50 border-amber-200', icon: 'bg-amber-100 text-amber-600' },
};

/** Collapsible card used for each block of the session report. */
export default function ReportSection({ title, subtitle, icon, tone = 'gray', defaultOpen = true, children }) {
  const [open, setOpen] = useState(defaultOpen);
  const { head, icon: iconClass } = TONES[tone];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`w-full bg-gradient-to-r ${head} px-6 py-4 border-b text-left`}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${iconClass}`}>
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={icon} />
              </svg>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-900">{title}</h4>
              {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
            </div>
          </div>
          <ChevronDownIcon className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
        </div>
      </button>
      {open && <div className="p-6">{children}</div>}
    </div>
  );
}

export const SECTION_ICONS = {
  document: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  link: 'M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1',
  shield: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
  book: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
};
